import { DevicePlatform } from '@core/enums/device-platform.enum';
import { EmailSubmissionPayload } from '@core/interfaces';
import { DeviceInfo, ProblemDescription } from '@core/models';
import { ContactInfo } from '@core/models/contact-info.model';
import { CustomerContext } from '@core/types/customer-context.type';

import { encodeBase64 } from './base64';

const MAIL_ALIAS = 'assistance.digitale';

function deviceToRecord(device: DeviceInfo): Record<string, string> {
  if (device.platform === DevicePlatform.APP) {
    return {
      platform: device.platform,
      phoneModel: device.phoneModel,
      os: device.os,
      osVersion: device.osVersion,
      appVersion: device.appVersion,
    };
  }

  return {
    platform: device.platform,
    device: device.device,
    browser: device.browser,
    browserVersion: device.browserVersion,
  };
}

export function BuildMailContent(
  context: CustomerContext,
  description: ProblemDescription,
  device: DeviceInfo,
  contact: ContactInfo,
): string {
  const lines: string[] = [
    `Thème: ${description.theme ?? ''}`,
    `Description: ${description.description}`,
    ``,
    `Appareil :`,
    ...Object.entries(deviceToRecord(device)).map(([key, value]) => ` ${key}: ${value}`),
    '',
    'Coordonnées :',
  ];

  if (context !== 'guest') {
    lines.push(` Type de clientèle : ${contact.clientType}`);
    lines.push(` Numéro de client : ${contact.clientNumber}`);
  }
  lines.push(` Civilité : ${contact.civility ?? ''}`);
  lines.push(` Nom : ${contact.lastName ?? ''}`);
  lines.push(` Prénom : ${contact.firstName ?? ''}`);
  lines.push(` Téléphone : ${contact.countryCode} ${contact.phoneNumber}`);
  lines.push(` E-mail : ${contact.email}`);
  return lines.join('\n');
}

export function buildEmailPayload(
  context: CustomerContext,
  description: ProblemDescription,
  device: DeviceInfo,
  contact: ContactInfo,
): EmailSubmissionPayload {
  return {
    content: encodeBase64(BuildMailContent(context, description, device, contact)),
    recipient: [encodeBase64(MAIL_ALIAS)],
    subject: encodeBase64(description.theme ?? ''),
    ReplyTO: encodeBase64(MAIL_ALIAS),
    CC_recipient: [],
    BCC_recipient: [],
  };
}
